import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { TitleModule } from '@smatchy/components/components/shared-ui/title/title.module';
import {
  EnableLocationFailureReason,
  LocationAccessService,
} from '../../../../../core/domains/user/services/location-access.service';

export type LocationPermissionModalMode = 'enable' | 'os_unavailable';

@Component({
  selector: 'smatchy-location-permission-modal',
  templateUrl: './location-permission-modal.component.html',
  styleUrls: ['./location-permission-modal.component.scss'],
  imports: [IonicModule, TranslateModule, TitleModule],
})
export class LocationPermissionModalPage {
  @Input() mode: LocationPermissionModalMode = 'enable';
  @Input() blockReason: EnableLocationFailureReason = 'permission_denied';

  isLoading = false;

  constructor(
    private readonly modalController: ModalController,
    private readonly locationAccessService: LocationAccessService,
  ) {}

  get isOsUnavailableMode(): boolean {
    return this.mode === 'os_unavailable';
  }

  get titleKey(): string {
    if (!this.isOsUnavailableMode) {
      return 'LOCATION_PERMISSION_MODAL.TITLE';
    }
    return 'LOCATION_PERMISSION_MODAL.DEVICE_ACCESS_REQUIRED_TITLE';
  }

  get descriptionKey(): string {
    if (!this.isOsUnavailableMode) {
      return 'LOCATION_PERMISSION_MODAL.DESCRIPTION';
    }
    return 'LOCATION_PERMISSION_MODAL.DEVICE_ACCESS_REQUIRED_MESSAGE';
  }

  get primaryButtonKey(): string {
    if (!this.isOsUnavailableMode) {
      return 'LOCATION_PERMISSION_MODAL.BTN_TITLE';
    }
    return 'LOCATION_PERMISSION_MODAL.OPEN_SETTINGS';
  }

  async dismiss() {
    if (!this.isOsUnavailableMode) {
      this.locationAccessService.setLocationEnabled(false);
    }
    await this.modalController.dismiss(undefined, 'cancel');
  }

  async enableLocation() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    if (this.isOsUnavailableMode) {
      await this.modalController.dismiss({ blockReason: this.blockReason }, 'open_settings');
      return;
    }
    // Dismiss first: the OS permission dialog cannot reliably appear above
    // a full-screen Ionic modal on Android/iOS.
    await this.modalController.dismiss(undefined, 'enable_requested');
  }
}
